import { createSlice } from "@reduxjs/toolkit";

const policySlice = createSlice({
  name: "policy",
  initialState: {
    isLoading: false,
    policyCategory: [],
    policyList: [],
    currentPolicy: {},
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setPolicyCategory(state, action) {
      state.policyCategory = action.payload;
    },
    setPolicyList(state, action) {
      state.policyList = action.payload;
    },
    setCurrentPolicy(state, action) {
      state.currentPolicy = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setPolicyCategory,
  setPolicyList,
  setCurrentPolicy,
} = policySlice.actions;
export default policySlice.reducer;
